import React from "react";
import RequestFeedbackHandler from "../../../components/generic/RequestFeedbackHandler";
import TaxAdvisorClientsWrapper from "../TaxAdvisorClientsWrapper/TaxAdvisorClientsWrapper";
import { GetMyTaxAdvisorCompanyWithClientsQuery } from "../../Queries";
import { CompanyType } from "../../../global-query-types";

const TaxAdvisorClientsContainer = () => {
  const getRequest = GetMyTaxAdvisorCompanyWithClientsQuery(CompanyType.TaxService);

  const taxServices = getRequest.data?.getMyTaxAdvisorCompanyWithClients?.taxServicesProvided;

  return (
    <RequestFeedbackHandler requests={[getRequest]}>
      {taxServices && <TaxAdvisorClientsWrapper taxServices={taxServices} />}
    </RequestFeedbackHandler>
  );
};

export default TaxAdvisorClientsContainer;
